import React, { Component } from "react";

import Popconfirm from 'antd/lib/popconfirm';
import { notification, Spin, message } from 'antd';
import { Link } from "react-router-dom";

import SockJsClient from 'react-stomp';

import AppService from './../../../../service/app_service'
import ChatOnly from "../../../../component/chat_only";
import ChatList from "../../../../component/chat_list";

import TopBarComponent from './../../component/topbar_component'
import ModalComponent from './../../component/modal_component'

import AuthenticationService from "../../../../service/authentication_service";
import UrlService from '../../../../service/url_service'

import "./../../../../assets/assets.css";

var interval = null;
var downloadTimer = null;
class Invoice extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showChatOnly: false,
            showchatlist: false,
            showPriceUpdateview: false,
            isTourOpen: true,
            price: 380,
            quantity: 1,
            messages: [],
            orders: null,
            messagesCount: 0,
            id: 57,
            channel: 0,
            ref: props.match.params.ref,
            loading: false,
            showModal: false,
            paymentSuccessful: false,
        };

        this.inputOpenFileRef = React.createRef()
    }

    componentWillUnmount() {
        clearInterval(interval);
        clearInterval(downloadTimer);
    }

    componentWillMount() {
        // AppService.getOrderById(this.state.id).then(rec => {
        //     rec.channel = this.state.channel;
        //     this.acitvateChatView(rec);
        //   })
        this.getChatItemByRef(this.state.ref)
    }

    

    getChatItemByRef = async (id) => {
        this.setState({ loading: true, });
        AppService.getChatItemByRef(id).then(item => {

            if (Object.keys(item).length > 0) {
                console.log("item.data",item.data)
                this.setState({
                    chatParent: item.data, loading: true,
                });
                if (item && item.data)
                    this.getOrderById(item.data.requestId, item.data.channel);
            } else {
                message.error("Wrong transaction id")
            }

        })
    }

    getOrderById = (id, channel) => {
        // this.setState({ loading: true, });
        AppService.getOrderById(id).then(rec => {
            rec.channel = channel;
            this.setState({
                chatData: null,
                chatList: false,
                showPanel: false,
                rec: rec,
                thread: rec.thread,
                loading: false
            }, () => {
                this.acitvateChatView(rec);
            });

        })
    }


    acitvateChatList = () => {
        this.setState({
            showchatlist: true,
            showChatOnly: false,
            showPriceUpdateview: null
        });
    };
    closeChatList = () => {
        this.setState({
            showchatlist: false,
            showPriceUpdateview: null
        });
    };
    acitvateChatView = (data) => {
        if (!AuthenticationService.getToken()) {
            message.error("Kindly login.")
        } else {
            this.setState({
                chatData: data,
                amount: data.amount,
                rate: data.rate,
                showChatOnly: true,
                showchatlist: false,
            });
        }

    };

    close = () => {
        this.setState({
            showChatOnly: false,
            showPriceUpdateview: null
        });
    };
    closePriceUpdateview = (data) => {



        if (data) {
            this.setState({
                rate: data && data.rate,
                amount: data && data.amount,
                showPriceUpdateview: false,
            });
            data.xo = AuthenticationService.getToken();
            data.channel = AuthenticationService.getChannel();

            console.log(data)
            this.clientRef.sendMessage('/app/negotiate', JSON.stringify(data));
        } else {
            this.setState({
                showPriceUpdateview: false,
            });
        }

    };
    openPriceUpdateview = () => {
        this.setState({
            showPriceUpdateview: true,
        });
    };

    handleChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        });

    }

    sendMessage = () => {
        console.log('send message')
        this.clientRef.sendMessage('/app/user-all', JSON.stringify({
            name: 'Happy',
            message: 'Happynow',
            channel: 'channel'
        }));
    };

    setIsTourOpen = (status) => {
        this.setState({
            isTourOpen: status,
        });
    }

    openNotificationWithIcon = (type, msg, title) => {
        notification[type]({
            message: title,
            description: msg,
        });
    }

    sellInitiation = (amt, rate) => {
        const { chatData } = this.state;
        let channel = chatData.channel ? chatData.channel : chatData.mobileNumber + ":" + AuthenticationService.getMobileNumber() + ":" + chatData.id;
        let data = {};
        data.amount = amt;
        data.rate = rate && rate > 0 ? rate : 1;
        data.xo = AuthenticationService.getToken();
        data.channel = channel;
        data.requestId = chatData.id;
        data.thread = {};
        data.thread.id = this.state.thread.id;
        this.clientRef.sendMessage('/app/sell/time', JSON.stringify(data));
        this.setState({
            message: '', loading: true
        });
    };

    makePayment = (debitMyAccount) => {
        const { chatData } = this.state;
        let channel = chatData.channel ? chatData.channel : chatData.mobileNumber + ":" + AuthenticationService.getMobileNumber() + ":" + chatData.id;
        let data = {};
        data.xo = AuthenticationService.getToken();
        data.emailAddress = AuthenticationService.getEmail();
        data.channel = channel;
        data.requestId = chatData.id;
        data.thread = {};
        data.debitMyAccount = debitMyAccount;
        data.thread.id = this.state.thread.id;
        this.clientRef.sendMessage('/app/make/payment', JSON.stringify(data));
        this.setState({
            message: '', loading: true
        });
    };

    balanceEnquiry = (amt, rate) => {
        const { chatData } = this.state;
        let channel = chatData.channel ? chatData.channel : chatData.mobileNumber + ":" + AuthenticationService.getMobileNumber() + ":" + chatData.id;
        let data = {};
        data.amount = amt;
        data.rate = rate && rate > 0 ? rate : 1;
        data.xo = AuthenticationService.getToken();
        data.channel = channel;
        data.requestId = chatData.id;
        this.clientRef.sendMessage('/app/check/balance', JSON.stringify(data));
        this.setState({
            message: '', loading: true
        });
    };

    handoverConfirmation = () => {
        const { chatData } = this.state;
        let channel = chatData.channel ? chatData.channel : chatData.mobileNumber + ":" + AuthenticationService.getMobileNumber() + ":" + chatData.id;
        let data = {};
        data.amount = this.state.amount;
        data.rate = this.state.rate && this.state.rate > 0 ? this.state.rate : 1;
        data.requestId = chatData.id;
        data.xo = AuthenticationService.getToken();
        data.channel = channel;
        this.clientRef.sendMessage('/app/handover/confirmation', JSON.stringify(data));
        this.setState({
            message: '', loading: true
        });
    };

    markAsRead = () => {
        let data = {};
        data.xo = AuthenticationService.getToken();
        data.channel = AuthenticationService.getChannel();

        this.clientRef.sendMessage('/app/read', JSON.stringify(data));
    };

    raiseAnIssue = () => {
        let data = {};
        data.xo = AuthenticationService.getToken();
        data.channel = AuthenticationService.getChannel();

        this.clientRef.sendMessage('/app/report/issue', JSON.stringify(data));
    };
    scrollDown = () => {
        setTimeout(() => {

            let shoppingListContainer = document.getElementById("dan-conversation");
            if (shoppingListContainer)
                shoppingListContainer.scrollTop = shoppingListContainer.scrollHeight;

        }, 300);


    }

    paymentCallback = (data) => {
        console.log(data);
        this.balanceEnquiry(this.state.amount, this.state.rate);
    }

    registerOrder = (checkoutData) => {
        this.setState({ loading: true, });
        checkoutData.userId = AuthenticationService.getUserId();
        AppService.registerOrder(checkoutData).then(rec => {
            if (!rec.code) {
                // const identifier = Math.random().toString(36).substr(2, 5)+""+new Date().getTime();
                // AuthenticationService.setIdentifier(identifier);
                // this.props.getCart();
                //toast("success", "Successfully done");
                if (rec.action === 'REGISTRATION_DONE') {
                    //set the ref to the items
                    // console.log("checkoutData:",checkoutData)
                    for (var i = 0; i < rec.items.length; i++) {
                        checkoutData.items[i].transactionRef = rec.items[i].ref;
                    }
                    console.log("checkoutData:", checkoutData)
                    this.setState({
                        account: rec.account, order: rec.order, checkoutData: checkoutData, loading: false
                    });
                    this.startCounter(rec.timeFrame * 60);
                    this.paymentConfirmationCron();
                }
            } else {
                message.error(rec.description)
            }

        })
    }

    payWithAccount = () => {
        let data = {};
        data.order = {};
        data.order.orderRef = this.state.ref;
        this.setState({ loading: true, });
        AppService.payWithAccount(data).then(rec => {
            this.setState({ loading: false, });
            if (!rec.code) {
                if (rec.action === 'SUCCESS') {
                    message.success(rec.message);
                    this.setState({
                        showModal: false
                    });
                    this.balanceEnquiry(this.state.amount, this.state.rate);
                }
            } else {
                message.error(rec.description);
            }

        })

    }

    paymentConfirmationCron = () => {
        navigator.serviceWorker.ready.then(registration => {
            interval = setInterval(() => {
                this.paymentConfirmation(false);
                //registration.showNotification(title, options)
            }, 10000)
        })
    }

    paymentConfirmation = (alerter) => {
        this.setState({ loading: alerter, });
        let data = {};
        data.order = {};
        data.order.orderRef = this.state.ref;
        AppService.paymentConfirmation(data).then(rec => {

            this.setState({ loading: false, });
            if (!rec.code) {
                // const identifier = Math.random().toString(36).substr(2, 5)+""+new Date().getTime();
                // AuthenticationService.setIdentifier(identifier);
                // this.props.getCart();
                //toast("success", "Successfully done");
                if (rec.action === 'SUCCESS') {
                    message.success(rec.message);
                    //call back for order to be checked out
                    clearInterval(interval);
                    clearInterval(downloadTimer);
                    var element = document.getElementById("countdown");
                    if (element)
                        element.innerHTML = rec.message;

                    this.setState({
                        showModal: false
                    });
                    this.balanceEnquiry(this.state.amount, this.state.rate);
                }
            } else {
                if(rec.description == 'Transaction has expired'){
                    clearInterval(interval);
                    clearInterval(downloadTimer);
                    var element = document.getElementById("countdown");
                    if (element)
                        element.innerHTML = rec.message;

                    message.error(rec.description);
                    this.setState({
                        showModal: false
                    });
                }
                else if (alerter){
                    message.error(rec.description)
                }     
            }
        })

    }

    startCounter = (timeleft) => {
        downloadTimer = setInterval(function () {
            if (timeleft <= 4) {
                clearInterval(downloadTimer);
                if (document.getElementById("countdown") != null)
                    document.getElementById("countdown").innerHTML = "Time is up";
            } else {
                var minutes = Math.floor(timeleft / 60);
                var seconds = timeleft - (minutes * 60);
                var left = minutes + ":" + seconds;
                var element = document.getElementById("countdown");
                if (element)
                    element.innerHTML = left;

            }
            timeleft -= 1;
        }, 1000);
    }

    sendReview = () => {
        const { review, chatData } = this.state;
        let channel = chatData.channel ? chatData.channel : chatData.mobileNumber + ":" + AuthenticationService.getMobileNumber() + ":" + chatData.id;

        let data = {};
        data.message = review;
        data.channel = channel;
        data.id = chatData.id;

        this.closeReview(data);
    };

    closeReview = (data) => {
        data.xo = AuthenticationService.getToken();

        this.clientRef.sendMessage('/app/review', JSON.stringify(data));
        this.setState({
            review: '',
            showAction: false,
        });
        message.success("Thanks for the review")

    };

    handleClickFile(type) {
        this.setState({
            uploadAction: type,
        }, () => {

            this.inputOpenFileRef.current.click()
        })

    }


    onChangeHandler = event => {

        this.setState({
            selectedFile: event.target.files[0], loading: true
        })
        let data = {
            upload: event.target.files[0]
        }
        AppService.uploadonly(data)
            .then(response => {

                if (response.code) {

                } else {
                    this.setState({ uploading: false })

                    const { chatData } = this.state;
                    let channel = chatData.channel ? chatData.channel : chatData.mobileNumber + ":" + AuthenticationService.getMobileNumber() + ":" + chatData.id;
                    let data = {};
                    data.name = AuthenticationService.getName();
                    data.message = response.documentName; // "<img src='" + img + "'  width='200' />";
                    data.xo = AuthenticationService.getToken();
                    data.type = "IMAGE";
                    data.channel = channel;
                    data.amount = this.state.amount;
                    data.rate = this.state.rate && this.state.rate > 0 ? this.state.rate : 1;
                    data.requestId = chatData.id;
                    this.clientRef.sendMessage('/app/' + this.state.uploadAction, JSON.stringify(data));
                    this.setState({
                        message: '',
                    });
                }

            })

    }

    closePaymentModal = () => {
        this.setState({
            showModal: false
        });
        clearInterval(interval);
        clearInterval(downloadTimer);
    }



    render() {
        const { rate, amount, chatData, account, chatParent, rec, thread, showReviewModal,paymentSuccessful, showModal, loading } = this.state;
        let channel = null;
        if (chatData) {
            channel = (chatData && chatData.channel) ? chatData.channel : chatData.mobileNumber + ":" + AuthenticationService.getMobileNumber() + ":" + chatData.id;

        }
        let totalAmount = thread && (parseFloat(thread.amount) + parseFloat(thread.platformFee));
        let request = {};
        request.publicKey = "";
        request.order = {
            mobileNumber: AuthenticationService.getMobileNumber(),
            emailAddress: AuthenticationService.getEmail(),
            totalAmount: totalAmount
        };
        request.items = [
            {
                amount: rec && rec.amount,
                mobileNumber: rec && rec.sellerMobileNumber,
                name: rec && rec.asset,
            },
        ];
        request.charges = [
            {
                "name": "Platform fee",
                amount: thread && parseFloat(thread.platformFee),
            }
        ];

        let chatIcon = <a className='blantershow-chate' onClick={() => this.acitvateChatView(this.state.rec)} title='Show Chat' >Open Chat <svg width="20" viewBox="0 0 24 24"><defs /><path fill="#eceff1" d="M20.5 3.4A12.1 12.1 0 0012 0 12 12 0 001.7 17.8L0 24l6.3-1.7c2.8 1.5 5 1.4 5.8 1.5a12 12 0 008.4-20.3z" /><path fill="#4caf50" d="M12 21.8c-3.1 0-5.2-1.6-5.4-1.6l-3.7 1 1-3.7-.3-.4A9.9 9.9 0 012.1 12a10 10 0 0117-7 9.9 9.9 0 01-7 16.9z" /><path fill="#fafafa" d="M17.5 14.3c-.3 0-1.8-.8-2-.9-.7-.2-.5 0-1.7 1.3-.1.2-.3.2-.6.1s-1.3-.5-2.4-1.5a9 9 0 01-1.7-2c-.3-.6.4-.6 1-1.7l-.1-.5-1-2.2c-.2-.6-.4-.5-.6-.5-.6 0-1 0-1.4.3-1.6 1.8-1.2 3.6.2 5.6 2.7 3.5 4.2 4.2 6.8 5 .7.3 1.4.3 1.9.2.6 0 1.7-.7 2-1.4.3-.7.3-1.3.2-1.4-.1-.2-.3-.3-.6-.4z" /></svg> </a>;
        return (
            <div id="main-wrapper" className="admin-dashboard-demos" style={{ background: '#e0e8f3',minHeight: '700px' }} >
                <TopBarComponent />

                <Spin size="large" spinning={this.state.loading}>
                    <div className="page-content" >
                        <div className="container" style={{ paddingBottom: '50px' }}>
                            <div className="content-area card">
                                <div className="card-innr">
                                    <div className="card-head d-flex justify-content-between align-items-center">
                                        <h4 className="card-title mb-0">Transaction Guide</h4>
                                        <Link to="/transactions" className="btn btn-sm btn-auto btn-primary d-sm-block d-none"><em className="fas fa-arrow-left mr-3" />Back</Link>
                                        <Link to="/transactions" className="btn btn-icon btn-sm btn-primary d-sm-none"><em className="fas fa-arrow-left" /></Link>
                                    </div>
                                    <p>The mission is to protect both parties in a trade against fraud. <br />
                                        A buyer can update the amount of this transaction before payment is made. <br />
                                        A seller must accept the amount and trade conditions before payment can be made, <br />
                                        Default flow and milestones are <br />
                                        1. Buyer makes payment to escrow,<br />
                                        2. Seller delivers <br />
                                        3. Buyer confirms delivery and seller gets paid 100%.<br />
                                        Note : Buyer can also disburse part payment before delivery if he wants to. <br />

                                        The chat engine is for communication and negotiation.</p>

                                    <span>
                                        {chatIcon}
                                    </span>

                                </div>
                                {/* .card-innr */}
                            </div>
                            <div className="card content-area">
                                <div className="card-innr" style={{ marginBottom: '60px' }} >
                                    <div className="card-head d-flex justify-content-between align-items-center">
                                        <h4 className="card-title mb-0">Transaction Details</h4>
                                    </div>
                                    <div className="gaps-1-5x" />
                                    <div className="data-details d-md-flex">
                                        <div className="fake-class"><span className="data-details-title">Tranx Date</span><span className="data-details-info">{chatParent && chatParent.createdAt}</span></div>
                                        <div className="fake-class"><span className="data-details-title">Tranx Status</span><span className={"badge  ucap " + ((chatData && chatData.status === "COMPLETED") ? "badge-success" : "badge-warning")}>{chatData && chatData.status}</span></div>
                                        <div className="fake-class">
                                            <span className="data-details-title">Amount : &#8358;{rec && parseFloat(rec.amount).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}</span>
                                            <span className="data-details-title">Fee : &#8358; {thread && (parseFloat(thread.platformFee).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,'))}</span>
                                        </div>
                                    </div>
                                    <div className="gaps-3x" />
                                    <h6 className="card-sub-title">Transaction Info</h6>
                                    <ul className="data-details-list">
                                        <li>
                                            <div className="data-details-head">Transaction Type</div>
                                            <div className="data-details-des"><strong>Purchase</strong></div>
                                        </li>
                                        {/* li */}
                                        <li>
                                            <div className="data-details-head">Asset</div>
                                            <div className="data-details-des"><strong>{rec && rec.asset}</strong></div>
                                        </li>
                                        {/* li */}
                                        <li>
                                            <div className="data-details-head">Deposit From</div>
                                            <div className="data-details-des"><strong>{chatParent && chatParent.buyerMobileNumber}</strong></div>
                                        </li>
                                        {/* li */}
                                        <li>
                                            <div className="data-details-head">Tx Hash</div>
                                            <div className="data-details-des"><strong>{chatParent && chatParent.ref}</strong> <span /></div>
                                        </li>
                                        {/* li */}
                                        <li>
                                            <div className="data-details-head">Deposit To</div>
                                            <div className="data-details-des"><strong>{chatParent && chatParent.sellerMobileNumber}</strong> <span /></div>
                                        </li>
                                        {/* li */}
                                        <li>
                                            <div className="data-details-head">Total Amount</div>
                                            <div className="data-details-des"><strong> &#8358;{rec && thread && ((parseFloat(rec.amount) + parseFloat(thread.platformFee)).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,'))}</strong></div>
                                        </li>
                                        {/* li */}
                                    </ul>
                                    {/* .data-details */}
                                </div>
                            </div>
                            {/* .card */}

                            {(thread) && <div className="card content-area" >
                                <div className="card-innr">
                                    <div className="card-head">
                                        <h4 className="card-title">Milestone</h4>
                                        {(false && thread && thread.acceptNegotiation === 1 && (chatParent && chatParent.buyerMobileNumber === AuthenticationService.getMobileNumber())) && <button className="btn btn-sm btn-auto btn-primary " style={{ float: 'right' }}><em className="fas fa-money mr-3" />Disburse Funds</button>}
                                    </div>
                                    <div className="timeline">
                                        <div className="timeline-line" />

                                        {
                                            (thread) &&
                                            <div className={"timeline-item " + (thread.acceptNegotiation === 1 ? "success" : "warning")}>
                                                <div className="timeline-time">{(thread.acceptNegotiation === 0 ? "Pending" : "Completed")}</div>
                                                <div className="timeline-content">
                                                    <div className="chat-users">

                                                        <span>Accept transaction</span>
                                                    </div>
                                                    <span className="timeline-content-info" style={{ display: 'inline-block' }}>{chatParent && chatParent.sellerMobileNumber}</span>
                                                    {(thread && thread.acceptNegotiation === 0 && (chatParent && chatParent.sellerMobileNumber === AuthenticationService.getMobileNumber())) && <span style={{ float: 'right' }}>
                                                        <button type="button" className="btn btn-sm btn-auto btn-primary " onClick={() => { this.sellInitiation(amount, rate) }}  >Accept transaction</button>
                                                    </span>}
                                                </div>
                                            </div>
                                        }

                                        {
                                            (thread) &&
                                            <div className={"timeline-item " + ((thread.paymentConfirmation === 1) ? "success" : "warning")}>
                                                <div className="timeline-time">{(thread.paymentConfirmation === 0 ? "Pending" : "Completed")}</div>
                                                <div className="timeline-content">
                                                    <div className="chat-users">

                                                        <span>Make Payment</span>
                                                    </div>
                                                    <span className="timeline-content-info" style={{ display: 'inline-block' }}>{chatParent && chatParent.buyerMobileNumber}</span>
                                                    {(thread && thread.acceptNegotiation === 1 && thread.paymentConfirmation === 0 && (chatParent && chatParent.buyerMobileNumber === AuthenticationService.getMobileNumber())) && <span style={{ float: 'right' }}>
                                                        

                                                        {<Popconfirm
                                                            title="Are you sure to submit this transaction?"
                                                            onConfirm={() => this.makePayment(false)}
                                                            okText="Yes"
                                                            cancelText="No"
                                                        >
                                                            <button type="submit" style={{float: 'right', marginRight: '18px'}} disabled={loading} name="submit" className="btn btn-sm btn-auto btn-primary">Make payment (Bank Transfer)</button>
                                                        </Popconfirm>}
                                                        {<Popconfirm
                                                            title="Are you sure to submit this transaction?"
                                                            onConfirm={() => this.makePayment(true)}
                                                            okText="Yes"
                                                            cancelText="No"
                                                        >
                                                            <button type="submit"  style={{float: 'right', marginRight: '18px'}}  disabled={loading} name="submit" className="btn btn-sm btn-auto btn-success">Make payment (Debit My Account)</button>
                                                        </Popconfirm>}
                                                    </span>}
                                                </div>
                                            </div>
                                        }

                                        {
                                            (thread) &&
                                            <div className={"timeline-item " + ((thread.buyerConfirmation === 1) ? "success" : "warning")}>
                                                <div className="timeline-time">{(thread.buyerConfirmation === 0 ? "Pending" : "Completed")}</div>
                                                <div className="timeline-content">
                                                    <div className="chat-users">

                                                        <span>Delivery Confirmation</span>
                                                    </div>
                                                    <span className="timeline-content-info" style={{ display: 'inline-block' }}>{chatParent && chatParent.buyerMobileNumber}</span>
                                                    {(thread && thread.acceptNegotiation === 1 && thread.paymentConfirmation === 1 && thread.buyerConfirmation === 0 && (chatParent && chatParent.buyerMobileNumber === AuthenticationService.getMobileNumber())) && <span style={{ float: 'right' }}>
                                                        <button type="button" className="btn btn-sm btn-auto btn-primary " onClick={() => { this.handoverConfirmation() }} >Confirm delivery</button>
                                                    </span>}

                                                </div>
                                            </div>
                                        }

                                        {
                                            (thread) &&
                                            <div className={"timeline-item " + ((thread.buyerConfirmation === 1) ? "success" : "warning")}>
                                                <div className="timeline-time">{(thread.buyerConfirmation === 0 ? "Pending" : "Completed")}</div>
                                                <div className="timeline-content">
                                                    <div className="chat-users">

                                                        <span>Payment to seller</span>
                                                    </div>
                                                    <span className="timeline-content-info" style={{ display: 'inline-block' }}>Escrow (Smart contract)</span>
                                                </div>
                                            </div>
                                        }


                                    </div>
                                </div>
                            </div>}
                        </div>
                        {/* .container */}
                    </div>
                    {this.state.showchatlist && <ChatList startConvo={(data) => this.acitvateChatView(data)} close={() => this.closeChatList()} />}


                    <a className='blantershow-chat' style={{ padding: '10px 20px' }} onClick={() => this.acitvateChatList()} title='Show Chat' ><svg width="20" viewBox="0 0 24 24"><defs /><path fill="#eceff1" d="M20.5 3.4A12.1 12.1 0 0012 0 12 12 0 001.7 17.8L0 24l6.3-1.7c2.8 1.5 5 1.4 5.8 1.5a12 12 0 008.4-20.3z" /><path fill="#4caf50" d="M12 21.8c-3.1 0-5.2-1.6-5.4-1.6l-3.7 1 1-3.7-.3-.4A9.9 9.9 0 012.1 12a10 10 0 0117-7 9.9 9.9 0 01-7 16.9z" /><path fill="#fafafa" d="M17.5 14.3c-.3 0-1.8-.8-2-.9-.7-.2-.5 0-1.7 1.3-.1.2-.3.2-.6.1s-1.3-.5-2.4-1.5a9 9 0 01-1.7-2c-.3-.6.4-.6 1-1.7l-.1-.5-1-2.2c-.2-.6-.4-.5-.6-.5-.6 0-1 0-1.4.3-1.6 1.8-1.2 3.6.2 5.6 2.7 3.5 4.2 4.2 6.8 5 .7.3 1.4.3 1.9.2.6 0 1.7-.7 2-1.4.3-.7.3-1.3.2-1.4-.1-.2-.3-.3-.6-.4z" /></svg> Inbox <span class="badger">{this.state.messagesCount}</span></a>
                    {this.state.showChatOnly && !this.state.showPriceUpdateview && <ChatOnly chatData={chatData} clientRef={this.clientRef} close={() => this.close()} openPriceUpdate={() => this.openPriceUpdateview()} rate={rate} amount={amount} />}
                </Spin>


                {showModal && <ModalComponent show={showModal} closeModal={() => this.closePaymentModal()} title="Make payment" >
                    <div>

                        {!paymentSuccessful && <div>
                            <p>Please make a bank transfer to the account detail below.</p>
                            <div className="gaps-1x" />
                            {/* <h6 className="font-bold">Payment to the following bank detail</h6> */}
                            <div className="row">
                                <div className="col-sm-4">
                                    <h6 style={{paddingTop: '20px'}}>Account Number</h6>
                                </div>
                                <div className="col-sm-8">
                                    <div className="copy-wrap mgb-0-5x" style={{fontSize: '20px', fontWeight: 400}}>
                                        <span className="copy-feedback" style={{ display: 'none' }}>Copied to Clipboard</span>
                                        <em className="fab fa-account" />
                                        <input type="text" className="copy-address" style={{padding: '12px 30px 12px 20px'}} defaultValue={account && account.accountNumber} disabled />
                                        <button onClick={() => { navigator.clipboard.writeText(account && account.accountNumber); message.info(' Copied to Clipboard') }} className="copy-trigger copy-clipboard" data-clipboard-text={account && account.accountNumber}><em className="ti ti-files" /></button>
                                    </div>
                                </div>
                            </div>
                            
                            {/* .copy-wrap */}
                            <ul className="pay-info-list row">
                                <li className="col-sm-12" style={{fontSize: '15px', fontWeight: 400}}><span>Bank:</span> <strong>{account && account.bank}</strong></li>
                                <li className="col-sm-12" style={{fontSize: '15px', fontWeight: 400}}><span>Account Name:</span> <strong>{account && account.accountName}</strong></li>
                                <li className="col-sm-12" style={{fontSize: '15px', fontWeight: 400}}><span>Amount:</span> <strong style={{fontSize: '18px'}}>&#8358; {account && account.totalAmount && account.totalAmount.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}</strong></li>
                            </ul>
                            
                            <div style={{fontSize: '16px', color: 'red'}}>You have to make payment in the next <h5 id="countdown"></h5></div>
                            
                            <div className="note note-plane note-light mgb-1x" style={{fontSize: '16px'}}>
                                <em className="fas fa-info-circle" />
                                <p>Do not make payment to another account.</p>
                            </div>
                            <div className="note note-plane note-danger" style={{fontSize: '16px'}}>
                                <em className="fas fa-info-circle" />
                                <p>Send the exact amount stated above. Nothing more, nothing less</p>
                            </div>
                            <div className="note note-plane note-danger" style={{fontSize: '16px', marginTop: '10px'}}>
                                <em className="fas fa-info-circle" />
                                <p>You can also pay with your funded account by clicking on <strong> Pay With My Account</strong></p>
                            </div>
                            <div className="gaps-3x" />
                            <button className="btn btn-primary" style={{float: 'right'}} onClick={() => this.paymentConfirmation(true)} >Confirm Payment  <em className="ti ti-arrow-right mgl-4-5x" /></button>
                            
                            <button className="btn btn-success" style={{float: 'right', marginRight: '8px'}} onClick={() => this.payWithAccount()} >Pay With My Account<em className="ti ti-arrow-right mgl-4-5x" /></button>

                            
                        </div>}




                        {paymentSuccessful && <div className="status status-thank px-md-5">
                            <div className="status-icon"><em className="ti ti-check" /></div>
                            <span className="status-text large text-dark">Thank you for submitting form</span>
                            <p className="px-md-5">We received your data, our team will check and get back you via email.</p>
                        </div>}





                    </div>
                </ModalComponent>}

                {chatData && <SockJsClient url={UrlService.BASE_PATH + '/unified/'}
                    topics={['/queue/chat/' + channel]}
                    onConnect={() => {
                        console.log("connected");
                        let data = {};
                        data.channel = channel;
                        // this.setState({ loading: true });
                        this.clientRef && this.clientRef.sendMessage('/app/chat/messages', JSON.stringify(data));
                    }}
                    onDisconnect={() => {
                        console.log("Disconnected");
                    }}
                    onMessage={(msg) => {
                        console.log("mssg", msg)

                        if (msg.action === "CHAT_MESSAGES") {
                            var thread = msg.thread ? msg.thread : this.state.thread;
                            var history = (msg.histories && msg.histories.length > 0) ? msg.histories[0] : null;
                            var rate = this.state.rate;
                            var amount = this.state.amount;
                            if (history) {
                                rate = history.rate;
                                amount = history.amount;
                            }
                            this.setState({
                                messages: msg.messages, amount: thread.amount, rate: rate, thread: thread, loading: false,
                                histories: msg.histories, history: history, messagesCount: msg.messages ? msg.messages.length : 0
                            });
                            this.scrollDown();
                        } else if (msg.action === "NEGOTIATION") {
                            var thread = msg.thread ? msg.thread : this.state.thread;
                            var jobs = this.state.messages;
                            jobs.push(msg);

                            var histories = this.state.histories;
                            histories.push(msg.history);

                            this.setState({
                                messages: jobs, rate: msg.rate, amount: msg.amount, thread: thread,
                                loading: false, showAction: !this.state.showAction, histories: histories, showConvo: true
                            });
                            this.scrollDown();
                        } else if (msg.action === "ERROR") {
                            message.error(msg.message);
                            this.setState({
                                loading: false
                            });
                            this.scrollDown();
                        } else if (msg.action === "SUCCESS") {
                            message.success(msg.message);
                            var thread = msg.thread ? msg.thread : this.state.thread;
                            this.setState({
                                loading: false,thread: thread,
                            });
                            this.scrollDown();
                        }  else if (msg.action === "MAKE_PAYMENT") {
                            var thread = msg.thread ? msg.thread : this.state.thread;
                            this.setState({
                                account: msg.account, amount: thread.amount, thread: thread,
                                loading: false, showConvo: true, showModal: true
                            });
                            this.startCounter(msg.timeFrame * 60);
                            this.paymentConfirmationCron();
                            this.scrollDown();

                        } else {
                            var thread = msg.thread ? msg.thread : this.state.thread;
                            var jobs = this.state.messages;
                            jobs.push(msg);
                            this.setState({ messages: jobs, thread: thread, amount: thread.amount, loading: false, showConvo: true });
                            this.scrollDown();
                        }
                        this.markAsRead();

                        // console.log(this.state);
                    }}
                    ref={(client) => {
                        this.clientRef = client
                    }} />}



            </div>
        );
    }
}

export default Invoice;
